import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class MailchimpLoginService {
    httpOptions = {};

    constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) {
        this.httpOptions = authenticationService.getHeaders();
    }

    checkIfApiKeyExists() {
        return this.httpClient.get<any>(environment.baseUrl + '/mailchimp/keyExists', this.httpOptions);
    }

    pushApiKey(apiKey: string) {
        return this.httpClient.post<boolean>(environment.baseUrl + `/mailchimp/addKey`, apiKey, this.httpOptions);
    }

    removeApiKey() {
        return this.httpClient.post<boolean>(environment.baseUrl + `/mailchimp/removeKey`, '', this.httpOptions);
    }
}
